import React from 'react';
import Sidenavigation from '../layout/Sidenavigation'
import Topnavigation from '../layout/Topnavigation';
import Content from '../sections/Helpdesk-Vendors-Details/Content';
import { Helmet } from "react-helmet";

export default function HelpdeskVendorDetails() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title  */}
            <Helmet>
                <title>Vendor Details</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start  */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content />
                {/* page content end  */}

            </main>

        </div>
    );
};